import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../services/httpService";
import messagePopup from "../../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_METRICS_LIST_START: "ALL_METRICS_LIST_START",
  ALL_METRICS_LIST_SUCCESS: "ALL_METRICS_LIST_SUCCESS",
  ALL_METRICS_LIST_FAILED: "ALL_METRICS_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const allMetricsListStart = (data) => ({
  type: actionType.ALL_METRICS_LIST_START,
  payload: data,
});

export const allMetricsListSuccess = (data) => ({
  type: actionType.ALL_METRICS_LIST_SUCCESS,
  payload: data,
});

export const allMetricsListFailed = (data) => ({
  type: actionType.ALL_METRICS_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allMetricsListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_METRICS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_METRICS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.ALL_METRICS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* allMetricsListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        allMetricsListSuccess({
          allMetrics: response.data.data.allStatmatrices.Statmatrices,
        })
      );
    } else {
      messagePopup("", "Metrics List failed", "error");
      yield put(allMetricsListFailed("Metrics List failed"));
    }
  } catch (error) {
    messagePopup("", "Metrics List failed", "error");
    yield put(allMetricsListFailed("Metrics List failed"));
  }
}

//Watcher
export function* watchAllMetricsListSaga() {
  yield takeEvery(actionType.ALL_METRICS_LIST_START, allMetricsListSaga);
}
